var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.unitPanelContentComponent,{tag:"component",attrs:{"project-element":_vm.unit,"access-links-enabled":_vm.accessLinksEnabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }